import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, GraduationCap, CheckCircle2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const Programs = () => {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/programs"); setPrograms(Array.isArray(data) ? data : data.programs || []); }
      catch (e) { toast.error("Could not load programs"); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="px-4 sm:px-6 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold flex items-center gap-2"><GraduationCap className="w-7 h-7 text-primary" /> Programs</h1>
        <p className="text-muted-foreground mt-2 mb-8">Multi-day journeys to build lasting change, one day at a time.</p>
        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>
        ) : programs.length === 0 ? (
          <p className="text-muted-foreground py-8">No programs available yet.</p>
        ) : (
          <div className="grid sm:grid-cols-2 gap-5" data-testid="programs-grid">
            {programs.map((p) => {
              const pct = p.duration_days ? Math.round((p.current_day / p.duration_days) * 100) : 0;
              return (
                <button key={p.program_id} data-testid="program-card" onClick={() => navigate(`/programs/${p.program_id}`)}
                  className="text-left bg-card border border-border rounded-2xl p-6 hover:border-primary transition-colors">
                  <div className="flex items-start justify-between mb-3">
                    <span className="inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full bg-primary/15 text-primary font-medium capitalize">{p.category}</span>
                    <span className="text-xs text-muted-foreground">{p.duration_days} days</span>
                  </div>
                  <p className="font-heading text-lg font-semibold leading-snug">{p.title}</p>
                  <p className="text-sm text-muted-foreground mt-2 line-clamp-3">{p.description}</p>
                  <div className="mt-4 flex items-center justify-between">
                    {p.enrolled ? (
                      p.completed ? (
                        <span className="flex items-center gap-1.5 text-sm text-seafoam font-medium"><CheckCircle2 className="w-4 h-4" /> Completed</span>
                      ) : (
                        <span className="text-sm text-muted-foreground">Day {p.current_day} · {pct}%</span>
                      )
                    ) : (
                      <span className="text-sm text-primary font-medium">Start journey</span>
                    )}
                    <ArrowRight className="w-5 h-5 text-muted-foreground" />
                  </div>
                  {p.enrolled && !p.completed && (
                    <div className="mt-2 h-1.5 rounded-full bg-secondary overflow-hidden">
                      <div className="h-full bg-primary" style={{ width: `${pct}%` }} />
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Programs;
